<template>
  <div>
    <div class="banner">
      <div class="banner-content">
        <img
          class="img-fluid"
          src="../assets/images/banner/calendar_banner.jpg"
          alt="banner"
        />
        <div class="banner-text">
          <h1>行事曆</h1>
          <div class="banner-text-line"></div>
          <span>Calendar</span>
        </div>
      </div>
    </div>
    <div
      class="contentContainer-noMove"
      :style="{ backgroundImage: 'url(' + BG + ')' }"
    >
      <div class="content">
        <div class="calendarContainer">
          <div class="calendarBody">
            <full-calendar
              :events="fcEvents"
              @eventClick="showEvent"
              @changeMonth="changeMonth"
              ref="calendar"
            >
              <div slot="fc-header-left">
                <ul class="list-unstyled calendar-ul">
                  <!-- <li class="red">最新消息</li> -->
                  <li class="orange">會員大會</li>
                  <li class="green">學術研討會</li>
                  <li class="skyBlue">相關合辦活動</li>
                </ul>
              </div>
            </full-calendar>
            <a
              class="event_popup animated fadeInDown"
              ref="popup"
              v-show="eventId"
              href="#"
              @click="toActivity(eventId)"
            >
              <div class="time">{{ showEventData.Title }}</div>
              <!-- <div class="title">{{showEventData.Title}}</div> -->
              <div class="image">
                <img v-if="showEventData.Picture"
                  :src="showEventData.Picture"
                />
                <img v-else
                  :src="defaultImg"
                />
              </div>
              <div class="info">
                <div class="icon icon-calendar"></div>
                <span>{{ showEventData.Date }}</span>
              </div>
              <div class="info" v-if="showEventData.Position">
                <div class="icon icon-place"></div>
                <span>{{ showEventData.Position }}</span>
              </div>
              <div class="info" v-if="showEventData.Organizer">
                <div class="icon icon-organizer"></div>
                <span>{{ showEventData.Organizer }}</span>
              </div>
            </a>
          </div>
          <div class="calendarInfo">
            <div class="title">本月資訊</div>
            <ul class="tag">
              <li
                class="calendarInfo-li active"
                @click="setSupervisory('event')"
              >
                本月活動
              </li>
              <!-- <li class="calendarInfo-li" @click="setSupervisory('news')">
                本月消息
              </li> -->
            </ul>
            <template v-if="type === 'event'">
              <a
                href="#"
                class="calendarInfo-card"
                v-for="(item, index) in events"
                :key="index"
                @click.prevent="toActivity(item.Id)"
              >
                <div class="newsCard-content">
                  <div class="newsCard-content-left">
                    <div class="newsCard-date">
                      <div class="newsCard-date-month">
                        <div class="day">{{ item.ActivityStartOn | moment("DD") }}</div>
                        <div class="month">
                          {{ item.ActivityStartOn | monthFormat }}
                        </div>
                      </div>
                      <div class="newsCard-date-year">
                        {{ item.ActivityStartOn | moment("YYYY") }}
                      </div>
                    </div>
                    <div class="newsCard-tag">
                      <div
                        class="eventCard-detail-tag eventRed"
                        v-if="item.CategoryId === '0'"
                      >
                        最新消息
                      </div>
                      <div
                        class="eventCard-detail-tag eventOrange"
                        v-if="item.CategoryId === '1'"
                      >
                        會員大會
                      </div>
                      <div
                        class="eventCard-detail-tag eventGreen"
                        v-if="item.CategoryId === '2'"
                      >
                        學術研討會
                      </div>
                      <div
                        class="eventCard-detail-tag eventSkyBlue"
                        v-if="item.CategoryId === '3'"
                      >
                        相關合辦活動
                      </div>
                    </div>
                  </div>
                  <div class="newsCard-content-right">
                    <div class="newsCard-content-title">
                      {{ item.Title }}
                    </div>
                    <ul class="list-unstyled">
                      <!-- 0514 暫時拿掉日期 -->
                      <!-- <li v-if="item.StartOn">
                        <img src="../assets/images/icon/calander_s.png" alt />
                        活動日期：{{ item.StartOn | moment("YYYY.MM.DD") }}~{{
                          item.EndOn | moment("YYYY.MM.DD")
                        }}
                      </li> -->
                      <li v-if="item.Location">
                        <img src="../assets/images/icon/pin_s.png" alt />
                        活動位置：{{ item.Location }}
                      </li>
                    </ul>
                  </div>
                </div>
              </a>
            </template>
            <template v-if="type === 'news'">
              <a
                href="#"
                class="calendarInfo-card"
                v-for="item in news"
                :key="item.Id"
              >
                <div class="newsCard-content">
                  <div class="newsCard-content-left">
                    <div class="newsCard-date">
                      <div class="newsCard-date-month">
                        <div class="day">{{ item.ActivityStartOn | moment("DD") }}</div>
                        <div class="month">
                          {{ item.ActivityStartOn | monthFormat }}
                        </div>
                      </div>
                      <div class="newsCard-date-year">
                        {{ item.ActivityStartOn | moment("YYYY") }}
                      </div>
                    </div>
                    <div class="newsCard-tag">
                      <div
                        class="eventCard-detail-tag eventRed"
                        v-if="item.CategoryId === '0'"
                      >
                        最新消息
                      </div>
                      <div
                        class="eventCard-detail-tag eventOrange"
                        v-if="item.CategoryId === '1'"
                      >
                        會員大會
                      </div>
                      <div
                        class="eventCard-detail-tag eventGreen"
                        v-if="item.CategoryId === '2'"
                      >
                        學術研討會
                      </div>
                      <div
                        class="eventCard-detail-tag eventSkyBlue"
                        v-if="item.CategoryId === '3'"
                      >
                        相關合辦活動
                      </div>
                    </div>
                  </div>
                  <div class="newsCard-content-right">
                    <div class="newsCard-content-title">
                      {{ item.Title }}
                    </div>
                    <ul class="list-unstyled">
                      <li v-if="item.ActivityStartOn">
                        <img src="../assets/images/icon/calander_s.png" alt />
                        活動日期：{{ item.ActivityStartOn | dateFormat }}~{{
                          item.ActivityEndOn | dateFormat
                        }}
                      </li>
                      <li v-if="item.Location">
                        <img src="../assets/images/icon/pin_s.png" alt />
                        活動位置：{{ item.Location }}
                      </li>
                    </ul>
                  </div>
                </div>
              </a>
            </template>
          </div>
        </div>
        <div class="contact-back">
          <router-link to="/">
            回首頁
            <img src="../assets/images/icon/back_icon.png" alt="回首頁" />
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import activityApi from '@/assets/api/activity';
import BG from '../assets/images/index_bg_big.png';

export default {
  name: 'Calendar',
  data() {
    return {
      BG,
      fcEvents: [
        // {
        //   title: 'Event',
        //   start: '2020-10-05',
        //   // end: '2020-10-05',
        //   cssClass: 'eventRed',
        // },
        // {
        //   title: 'Event',
        //   start: '2020-10-10',
        //   end: '2020-10-12',
        //   cssClass: 'eventOrange',
        // },
        // {
        //   title: 'Event',
        //   start: '2020-10-15',
        //   end: '2020-10-17',
        //   cssClass: 'eventGreen',
        // },
        // {
        //   title: 'Event',
        //   start: '2020-10-20',
        //   end: '2020-10-21',
        //   cssClass: 'eventSkyBlue',
        // },
      ],
      eventList: [
        {
          Title: '嚴重特殊傳染性肺炎(COVID-19)研討會染性',
          StartOn: '2020-10-05',
          EndOn: '2020-10-05',
          CategoryId: '0',
          Location: '測試酒店',
          Type: 'news',
        },
        {
          Title: '嚴重特殊傳染性肺炎(COVID-19)研討會染性',
          StartOn: '2020-10-10',
          EndOn: '2020-10-12',
          CategoryId: '1',
          Location: '測試酒店',
          Type: 'event',
        },
        {
          Title: '嚴重特殊傳染性肺炎(COVID-19)研討會染性',
          StartOn: '2020-10-15',
          EndOn: '2020-10-17',
          CategoryId: '2',
          Location: '測試酒店',
          Type: 'event',
        },
        {
          Title: '嚴重特殊傳染性肺炎(COVID-19)研討會染性',
          StartOn: '2020-10-20',
          EndOn: '2020-10-21',
          CategoryId: '3',
          Location: '測試酒店',
          Type: 'event',
        },
      ],
      events: [],
      news: [],
      type: 'event',
      categrory: [],
      showEventData: [],
      defaultImg: require('@/assets/images/logo_big.jpg'),
      eventId: '',
    };
  },
  methods: {
    setSupervisory(type) {
      const vm = this;
      $('.calendarInfo-li').removeClass('active');
      // eslint-disable-next-line no-restricted-globals
      $(event.target).addClass('active');
      vm.type = type;
    },
    getActivities(month) {
      const vm = this;
      activityApi.getMonthActivity(month).then((res) => {
        if (res.status === 200) {
          vm.events = res.data.Data.Activities;
          vm.setDefaultData();
        }
      });
    },
    setDefaultData() {
      const vm = this;
      activityApi.getActivityCategory().then((res) => {
        if (res.status === 200) {
          const arr = [];
          vm.categrory = res.data.Data;
          vm.colors = vm.categrory.map((categroy, index) => {
            categroy.Color = `calendar_color${index + 1}`;
            return categroy;
          });
          new Promise((res, rj) => {
            vm.events.forEach((item) => {
              const obj = {
                title: '',
                start: '',
                end: '',
                YOUR_DATA: {
                  Id: '',
                  Time: '',
                  Picture: '',
                  Location: '',
                },
                cssClass: [],
              };
              obj.title = item.Title;
              obj.start = vm.$moment(item.ActivityStartOn).format('YYYY-MM-DD');
              obj.end = vm.$moment(item.ActivityEndOn).format('YYYY-MM-DD');
              obj.YOUR_DATA = {
                Id: item.Id,
                Time: vm.$moment(item.ActivityStartOn).format('HH:mm'),
                Location: item.Location,
                Picture: item.Picture,
                Organizer: item.Organizer,
              };
              vm.colors.forEach((categrory) => {
                if (categrory.Id === item.Categories[0]) {
                  obj.cssClass = [categrory.Color];
                }
              });
              // console.log(obj);
              arr.push(obj);
              res(arr);
            });
          }).then((data) => {
            vm.fcEvents = data;
          });
        }
      });
    },
    showEvent(params, jsEvent, pos) {
      // console.log(params);
      const vm = this;
      if (vm.isPhone) {
        location.href = `/activity/${params.YOUR_DATA.Id}`;
        return false;
      }
      const el = this.$refs.popup;
      if (vm.eventId === params.YOUR_DATA.Id) {
        if (vm.pos.top === pos.top && vm.pos.left === pos.left) {
          vm.eventId = '';
          vm.pos = {
            top: '',
            left: '',
          };
          return false;
        }
      }
      vm.pos = pos;
      if (vm.eventId === '') {
        vm.eventId = params.YOUR_DATA.Id;
      }
      vm.eventId = params.YOUR_DATA.Id;
      vm.$set(vm.showEventData, 'Time', params.YOUR_DATA.Time);
      vm.$set(vm.showEventData, 'Title', params.title);
      vm.$set(vm.showEventData, 'Picture', params.YOUR_DATA.Picture);
      vm.$set(vm.showEventData, 'Date', `${params.start}~${params.end}`);
      vm.$set(vm.showEventData, 'Organizer', params.YOUR_DATA.Organizer);
      vm.$set(vm.showEventData, 'Position', params.YOUR_DATA.Location);
      //   console.log("可套用的function", jsEvent);

      el.style.top = `${pos.top - 250}px`;
      // console.log(pos.left);
      const Left = document.body.clientWidth / 40;
      el.style.left = `${pos.left - Left}px`;
    },
    changeMonth(start, end, current) {
      const vm = this;
      if (!vm.callApi) {
        vm.callApi = true;
        return false;
      }
      // 關掉popup
      vm.eventId = '';
      vm.pos = {
        top: '',
        left: '',
      };
      const NowMonth = parseInt(vm.$moment(current).format('MM'), 10);
      const NowYear = parseInt(vm.$moment(current).format('YYYY'), 10);
      // console.log(NowMonth);
      if (NowMonth === 1) {
        document.querySelectorAll('.prev-month')[0].style.display = 'none';
      } else {
        document.querySelectorAll('.prev-month')[0].style.display = 'inline';
      }

      if (NowMonth === 12) {
        document.querySelectorAll('.next-month')[0].style.display = 'none';
      } else {
        document.querySelectorAll('.next-month')[0].style.display = 'inline';
      }
      const getData = {
        month: NowMonth,
        year: NowYear,
      };
      activityApi.getCalendarActivity(getData).then((result) => {
        if (result.status === 200) {
          // vm.events = res.Data.Activities;
          const Arr = [];
          new Promise((res, rj) => {
            result.data.Data.Activities.forEach((item) => {
              const obj = {
                title: '',
                start: '',
                end: '',
                YOUR_DATA: {
                  Id: '',
                  Picture: '',
                  Image: '',
                  Location: '',
                },
                cssClass: [],
              };
              obj.title = item.Title;
              obj.start = vm.$moment(item.ActivityStartOn).format('YYYY-MM-DD');
              obj.end = vm.$moment(item.ActivityEndOn).format('YYYY-MM-DD');
              obj.YOUR_DATA = {
                Id: item.Id,
                Time: vm.$moment(item.ActivityStartOn).format('HH:mm'),
                Location: item.Location,
                Picture: item.Picture,
                Organizer: item.Organizer,
              };
              vm.colors.forEach((categrory) => {
                if (categrory.Id === item.Categories[0]) {
                  obj.cssClass = [categrory.Color];
                }
              });

              Arr.push(obj);
              res(Arr);
            });
          }).then((data) => {
            // console.log("本月活動", data);
            vm.fcEvents = data;
          });
        }
      });
    },
    toActivity(id) {
      const vm = this;
      vm.$router.push(`/activity/${id}`);
    },
  },
  mounted() {},
  computed: {
    filterList() {
      const vm = this;
      let tmpList = [];
      tmpList = vm.eventList.filter((item) => item.Type === vm.type);

      return tmpList;
    },
  },
  created() {
    const vm = this;
    vm.getActivities(vm.$moment().format('M'));
  },
  filters: {
    dateFormat(data) {
      return data.replaceAll('-', '.');
    },
    dayFormat(data) {
      return data.split('-')[2];
    },
    monthFormat(data) {
      let tmpMonth = data.split('-');
      switch (tmpMonth[1]) {
        case '01':
          tmpMonth = 'JAN';
          break;
        case '02':
          tmpMonth = 'FEB';
          break;
        case '03':
          tmpMonth = 'MAR';
          break;
        case '04':
          tmpMonth = 'APR';
          break;
        case '05':
          tmpMonth = 'MAY';
          break;
        case '06':
          tmpMonth = 'JUN';
          break;
        case '07':
          tmpMonth = 'JUL';
          break;
        case '08':
          tmpMonth = 'AUG';
          break;
        case '09':
          tmpMonth = 'SEP';
          break;
        case '10':
          tmpMonth = 'OCT';
          break;
        case '11':
          tmpMonth = 'NOV';
          break;
        case '12':
          tmpMonth = 'DEC';
          break;

        default:
          break;
      }
      return tmpMonth;
    },
    yearFormat(data) {
      return data.split('-')[0];
    },
  },
};
</script>

<style lang="scss">
.calendarContainer {
  border: 1px solid #e3e3e3;
  padding: 30px 5px;
  display: flex;
  justify-content: center;
  background-color: #fff;
  @media (max-width: 767px) {
    flex-direction: column;
  }
}

.calendarBody {
  flex: 70%;
}

.calendarInfo {
  flex: 30%;

  .title {
    text-align: center;
    font-size: 1.8rem;
    color: #001139;
    font-weight: bold;
    margin-bottom: 1rem;
  }

  .tag {
    display: flex;
    justify-content: space-around;
    font-size: 1.1rem;

    li {
      cursor: pointer;
      color: #545454;

      &.active {
        color: #001139;
      }
    }
  }
}
.calendarBody {
  padding: 2rem 0;
  position: relative;
}

.full-calendar-body .dates .week-row .day-cell.today {
  background-color: #b8e9ff;
}
.full-calendar-body .dates .week-row .day-cell .day-number {
  text-align: left;
}
/* .full-calendar-body .dates .week-row .day-cell.not-cur-month .day-number {
    color: #001139;
} */
.comp-full-calendar ul,
.comp-full-calendar p {
  font-size: 18px;
}
.full-calendar-body .weeks .week:not(:last-child) {
  text-align: left;
  border-right: unset;
}
.full-calendar-body .weeks .week {
  text-align: left;
  font-size: 18px;
  color: #001139;
}
.full-calendar-body .dates .week-row {
  min-height: 109px;
}
.full-calendar-body
  .dates
  .dates-events
  .events-week
  .events-day
  .event-box
  .event-item {
  color: #fff;
}

.full-calendar-header .header-center {
  .title {
    position: absolute;
    top: 0;
    left: 0;
    font-size: 2rem;
    @media (max-width: 768px) {
      font-size: 1.5rem;
    }
  }
  .prev-month {
    position: absolute;
    font-size: 1.5rem;
    top: 5px;
    left: 30%;
    @media (max-width: 1680px) {
      left: 40%;
    }
    @media (max-width: 1024px) {
      left: 50%;
    }
    @media (max-width: 767px) {
      left: 70%;
      top: 0;
    }
  }
  .next-month {
    position: absolute;
    font-size: 1.5rem;
    top: 5px;
    left: 35%;
    @media (max-width: 1680px) {
      left: 45%;
    }
    @media (max-width: 1024px) {
      left: 55%;
    }
    @media (max-width: 767px) {
      left: 80%;
      top: 0;
    }
  }
}

.full-calendar-body
  .dates
  .dates-events
  .events-week
  .events-day
  .event-box
  .event-item.is-start {
  border-radius: 5px 0 0 5px;
}

.full-calendar-body
  .dates
  .dates-events
  .events-week
  .events-day
  .event-box
  .event-item.is-end {
  border-radius: 0 5px 5px 0;
}

.full-calendar-body
  .dates
  .dates-events
  .events-week
  .events-day
  .event-box
  .event-item.is-start.is-end {
  border-radius: 5px;
}

.full-calendar-header .header-left,
.full-calendar-header .header-right {
  flex: unset;
}

.calendar-ul {
  display: flex;
  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
  li {
    @media (max-width: 768px) {
      margin-bottom: 5px;
    }
  }
  .red {
    margin-right: 1rem;
    padding-left: 2rem;
    position: relative;
    &:before {
      content: "";
      position: absolute;
      background-color: #ff5555;
      width: 27px;
      height: 27px;
      left: 0;
      border-radius: 50%;
    }
  }
  .orange {
    margin-right: 1rem;
    padding-left: 2rem;

    position: relative;
    &:before {
      content: "";
      position: absolute;
      background-color: #f68e56;
      width: 27px;
      height: 27px;
      left: 0;
      border-radius: 50%;
    }
  }

  .green {
    margin-right: 1rem;
    padding-left: 2rem;

    position: relative;
    &:before {
      content: "";
      position: absolute;
      background-color: #4eaf57;
      width: 27px;
      height: 27px;
      left: 0;
      border-radius: 50%;
    }
  }

  .skyBlue {
    padding-left: 2rem;

    position: relative;
    &:before {
      content: "";
      position: absolute;
      background-color: #00b8ee;
      width: 27px;
      height: 27px;
      left: 0;
      border-radius: 50%;
    }
  }
}
.eventRed {
  background-color: #ff5555 !important;
}
.calendar_color1 {
  background-color: #f68e56 !important;
}
.calendar_color2 {
  background-color: #4eaf57 !important;
}
.calendar_color3 {
  background-color: #00b8ee !important;
}

.newsCard-content {
  display: flex;
  align-items: center;

  @media (max-width: 420px) {
    flex-direction: column;
  }
}

.newsCard-content-left {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 1rem;
  @media (max-width: 420px) {
    padding-left: 0;
  }
}

.newsCard-date {
  display: flex;
  align-items: center;
  color: #001139;
  transition: all 0.5s;
  padding: 1rem;
}

.newsCard-date-month {
  .day {
    font-size: 2.25rem;
    line-height: 1;
  }

  .month {
    font-size: 1.25rem;
  }
}

.newsCard-date-year {
  writing-mode: vertical-lr;
  font-size: 1.5rem;

  // @media (max-width: 1024px) {
  //   margin-right: 1rem;
  // }
}

.newsCard-tag {
}

.newsCard-content-right {
  padding: 0 1rem;
  width: 100%;
}

.newsCard-content-title {
  font-size: 1.5rem;
  color: #313131;
  padding: 0.5rem 3rem 0 0;

  @media (max-width: 420px) {
    padding: 0;
  }
}

.calendarInfo-card {
  border: 1px solid #a0a0a0;
  margin-bottom: 1rem;
  display: block;
  .newsCard-content {
    flex-direction: column;

    .newsCard-content-left {
      flex-direction: row;
      justify-content: flex-start;
      width: 100%;
      padding-left: 0;
    }
    .newsCard-content-right {
      .newsCard-content-title {
        padding: 0;
        margin-bottom: 0.5rem;
      }
    }
  }

  li {
    color: #212529;
  }

  &:hover {
    text-decoration: none;
  }
}

.event_popup {
    display: block;
    width: 250px;
    min-height: 360px;
    position: absolute;
    transition: 0.5s;
    padding: 10px;
    margin: auto;
    z-index: 98;
    background-color: #eee;
    border-radius: 5px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    text-decoration: none;
}
.event_popup::after {
    content: "";
    position: absolute;
    bottom: -14px;
    left: 0;
    right: 0;
    margin: auto;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 15px 10px 0 10px;

    border-color: #eee transparent transparent transparent;
}
.event_popup .time {
    background: #808081;
    padding: 5px 10px;
    line-height: 1.5;
    margin-bottom: 10px;
    border-radius: 5px;
    color: #fff;
    display: inline-block;
    letter-spacing: 3px;
    font-weight: normal;
    font-size: 0.8rem;
}
.event_popup .title {
    width: 100%;
    line-height: 1.5;
    padding: 8px 0;
}
.event_popup .image {
    width: 100%;
    font-size: 0;
    height: 150px;
}
.event_popup .image img {
    width: 100%;
    max-height: 100%;
}
.event_popup .info {
    display: flex;
    /* align-items: center; */
    padding: 5px 0;
    line-height: 1.5;
    color: #666;
}
.event_popup .info .icon {
    padding-right: 8px;
}
</style>
